// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Link } from 'react-router'
import { Col, Row } from 'react-bootstrap'
import { ActivityTable } from '../components/activityTable'
import { Message } from '../components/message'

export class WorkerResults extends Component {
    constructor(props) {
        super(props)

        const { activeResults, activeProviderId, activeModule } = this.props

        this.path = {
            modules: '/assets/images/Modules/'
        }

        this.state = {
            officialResults: this.setOfficialResults(activeResults, activeProviderId, activeModule),
            unofficialResults: this.setUnofficialResults(activeResults, activeProviderId, activeModule)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { activeResults, activeProviderId, activeModule } = prevProps
        let officialResults = this.setOfficialResults(activeResults, activeProviderId, activeModule)
        let unofficialResults = this.setUnofficialResults(activeResults, activeProviderId, activeModule)

        if (JSON.stringify(prevState.officialResults) !== JSON.stringify(officialResults)) {
            this.setState({
                officialResults
            })
        }

        if (JSON.stringify(prevState.unofficialResults) !== JSON.stringify(unofficialResults)) {
            this.setState({
                unofficialResults
            })
        }
    }

    setOfficialResults(activeResults) {
        return activeResults.filter(result => {
            return (result.official === true)
        })
    }

    setUnofficialResults(activeResults) {
        return activeResults.filter(result => {
            return (result.official !== true)
        })
    }

    displayResults() {
        if (this.props.activeResults.length === 0) {
            return (
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Message
                            text="No results data found for this module."
                        />
                    </Col>
                </Row>
            )
        }
        else {
            return (
                <section className="results">
                    <Row>
                        {this.prepareOfficialResults()}
                    </Row>
                    <Row>
                        {this.prepareUnofficialResults()}
                    </Row>
                </section>
            )
        }
    }

    prepareOfficialResults() {
        return (
            <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                <section className="official-results results">
                    <ActivityTable
                        results={this.state.officialResults}
                        title="Assessment Results"
                    />
                </section>
            </Col>
        )
    }

    prepareUnofficialResults() {
        return (
            <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                <section className="unofficial-results results">
                    <ActivityTable
                        results={this.state.unofficialResults}
                        title="Practice Results"
                    />
                </section>
            </Col>
        )
    }

    prepareBreadcrumb() {
        return (<div className="breadcrumb"><span><Link to="/individual">Training</Link></span>/<span><Link to="/individual">{this.props.activeProviderName}</Link></span>/</div>)
    }

    render() {
        return (
            <section className="worker-results">
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <div className="main-header">
                            {this.prepareBreadcrumb()}
                            <h2 className="title">My Performance</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <section className="module-info">
                            <h3 className="module-title">Module: {this.props.activeModule}</h3>
                        </section>
                    </Col>
                </Row>
                {this.displayResults()}
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/workerResults.js